package com.ives.modules.info;

import com.ives.components.workspace.DicomWorkspace;

class Info extends Module{
	static public inline var INFO_UPDATE:String = "INFO_UPDATE";

	private function update(){
		patientValue.innerHTML = '${fillMissing(dicomWorkspace.dicomImageData.patientName)}, ${fillMissing(dicomWorkspace.dicomImageData.patientSex)}, ${fillMissing(dicomWorkspace.dicomImageData.patientAge)}';
		institutionValue.innerHTML = '${fillMissing(dicomWorkspace.dicomImageData.institutionName)}';
		dateValue.innerHTML = '${DateTools.format(Date.fromTime(dicomWorkspace.dicomImageData.studyDate), "%Y/%m/%d %H:%M")}';
		modalityValue.innerHTML = '${dicomWorkspace.dicomImageData.modality}';
	}

	override public function handleModuleEvent(event:ModuleEvent){
		if(event.type == INFO_UPDATE)
			update();
	}

	public static function fillMissing(string:String):String{
		if(string == null)
			return '-';

		if(StringTools.replace(string, ' ', '').length == 0)
			return '-';

		string = StringTools.replace(string, '^', ' ');
		string = string.toUpperCase();

		return string;
	}
}
